import Vue from 'vue'
import VueI18n from 'vue-i18n'
import cloneDeep from 'lodash/cloneDeep'
import merge from 'lodash/merge'

Vue.use(VueI18n)

function getLocaleBase (locale) {
  const dash = locale.indexOf('-')
  if (dash <= 0) return null
  return locale.slice(0, dash)
}

function mergeLocaleMessages (rawMessages) {
  const messages = {}

  Object.keys(rawMessages).forEach(locale => {
    const base = getLocaleBase(locale)
    const regional = rawMessages[locale]
    const parent = base && rawMessages[base]

    messages[locale] = parent
      ? merge(cloneDeep(parent), regional)
      : regional
  })

  return messages
}

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const rawMessages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      rawMessages[locale] = locales(key)
    }
  })
  return mergeLocaleMessages(rawMessages)
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'pt-br',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'pt-br',
  messages: loadLocaleMessages()
})
